import { api } from '@/api';
import { ActionContext } from 'vuex';
import { State } from '../state';
import { NomenclatureState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { commitSetNonConventionalHonoraria, commitSetNonConventionalHonorarium, commitRemoveNonConventionalHonorarium} from './mutations';
import { dispatchCheckApiError } from '../main/actions';
import { INonConventionalHonorariumCreate, INonConventionalHonorariumUpdate } from '@/interfaces';
import { commitAddNotification, commitRemoveNotification } from '../main/mutations';
import { AxiosError } from 'axios';
import { i18n } from '@/plugins/i18n';

type MainContext = ActionContext<NomenclatureState, State>;

export const actions = {
  async actionGetNonConventionalHonoraria(context: MainContext) {
    try {
      const response = await api.getNonConventionalHonoraria();
      if (response) {
        console.log(response.data)
        console.log(response.data[0])
        commitSetNonConventionalHonoraria(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async createNonConventionalHonorarium(context: MainContext, payload: INonConventionalHonorariumCreate) {
    const loadingNotification = { content: String(i18n.t('common.save')), showProgress: true };
    try {
      commitAddNotification(context, loadingNotification);
      const response = (await Promise.all([
        api.createNonConventionalHonorarium(payload),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]))[0];
      commitSetNonConventionalHonorarium(context, response.data);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: String(i18n.t('nomenclatures.created')), color: 'success' });
    } catch (error) {
      if (error instanceof AxiosError && error.response){
        commitRemoveNotification(context, loadingNotification);
        console.log(error.response.data)
        if ('Duplicate generic duration' == error.response.data.detail){
          commitAddNotification(context, { content: String(i18n.t('nomenclatures.conflict')), color: 'error' });
        } else {
          commitAddNotification(context, { content: error.response.data, color: 'error' });
        }
      }
    }
  },
  async updateNonConventionalHonorarium(context: MainContext, payload: { id: number; payload: INonConventionalHonorariumUpdate }) {
    const loadingNotification = { content: String(i18n.t('common.updating')), showProgress: true };
    try {
      commitAddNotification(context, loadingNotification);
      const response = (await Promise.all([
        api.updateNonConventionalHonorarium(payload.id, payload.payload),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]))[0];
      commitSetNonConventionalHonorarium(context, response.data);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: String(i18n.t('nomenclatures.updated')), color: 'success' });
    } catch (error) {
      if (error instanceof AxiosError && error.response){
        commitRemoveNotification(context, loadingNotification);
        console.log(error.response.data)
        if ('Duplicate generic duration' == error.response.data.detail){
          commitAddNotification(context, { content: String(i18n.t('nomenclatures.conflict')), color: 'error' });
        } else {
          commitAddNotification(context, { content: error.response.data, color: 'error' });
        }
      }
    }
  },
  async deleteNonConventionalHonorarium(context: MainContext, payload: { id: number }) {
    try {
      const loadingNotification = { content: String(i18n.t('common.delete')), showProgress: true };
      commitAddNotification(context, loadingNotification);
      await Promise.all([
        api.deleteNonConventionalHonorarium(payload.id),
        await new Promise<void>((resolve) => setTimeout(() => resolve(), 500)),
      ]);
      commitRemoveNonConventionalHonorarium(context, payload.id);
      commitRemoveNotification(context, loadingNotification);
      commitAddNotification(context, { content: String(i18n.t('nomenclatures.deleted')), color: 'success' });
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<NomenclatureState, State>('');

export const dispatchGetNonConventionalHonoraria = dispatch(actions.actionGetNonConventionalHonoraria);
export const dispatchCreateNonConventionalHonorarium = dispatch(actions.createNonConventionalHonorarium);
export const dispatchUpdateNonConventionalHonorarium = dispatch(actions.updateNonConventionalHonorarium);
export const dispatchDeleteNonConventionalHonorarium = dispatch(actions.deleteNonConventionalHonorarium);